import React, { useState, useEffect } from 'react';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { statsService } from './services/stats';
// import book0 from './book0.png'; // Commented out - book banners are hidden
import gettingStartedImgAlt from './fluxlogoa.png';

interface TopNavigationProps {
  user?: any;
  onSignInClick?: () => void;
  onSignOut?: () => void;
}

const TopNavigation: React.FC<TopNavigationProps> = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  
  // Check if we're on the main page
  const isMainPage = location.pathname === '/';
  // const isBookPage = location.pathname === '/book'; // Commented out - book banners are hidden
  const isBlogPage = location.pathname.startsWith('/blog');
  const isActive = (path: string) => {
    if (path === '/') {
      // Don't highlight "Today's Case" if there's a date parameter (archive case)
      return location.pathname === '/' && !searchParams.get('date');
    }
    if (path === '/blog') {
      // Highlight blog if we're on any blog page
      return location.pathname.startsWith('/blog');
    }
    return location.pathname === path;
  };

  const getStreakCount = () => {
    // Check if we're in single proposal mode
    try {
      const savedState = localStorage.getItem('dimension23_game_state_v2');
      if (savedState) {
        const parsedState = JSON.parse(savedState);
        const isSingleProposalMode = parsedState.newGameMode !== undefined ? parsedState.newGameMode : true;
        
        if (isSingleProposalMode) {
          const singleProposalStats = statsService.getSingleProposalStats();
          return singleProposalStats.currentStreak || 0;
        }
      }
    } catch (error) {
      console.warn('Failed to read game mode from localStorage:', error);
    }
    
    // Default to single proposal mode or fallback to standard stats
    const singleProposalStats = statsService.getSingleProposalStats();
    return singleProposalStats.currentStreak || 0;
  };

  // Hide navigation on scroll for About and How to Play pages
  useEffect(() => {
    if (isMainPage) {
      setIsVisible(true);
      return;
    }

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // Scrolling down and past 100px - hide navigation
        setIsVisible(false);
      } else if (currentScrollY < lastScrollY) {
        // Scrolling up - show navigation
        setIsVisible(true);
      }
      
      setLastScrollY(currentScrollY);
    };

    // Only add scroll listener for non-main pages
    if (!isMainPage) {
      window.addEventListener('scroll', handleScroll, { passive: true });
      
      // Cleanup function
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }
  }, [lastScrollY, location.pathname, isMainPage]);





    return (
      <>
          <nav className={`sticky top-0 z-50 transition-transform duration-300 ${
            isMainPage ? 'translate-y-0' : (isVisible ? 'translate-y-0' : '-translate-y-full')
          }`}>
       <div className="max-w-2xl mx-auto px-2 sm:px-4">
        {/* Desktop Navigation */}
                                   <div className="hidden md:flex items-center justify-center h-12">
                                             <div className="flex items-center space-x-4 lg:space-x-6">
                                          <Link 
                 to="/" 
                 onClick={(e) => {
                   // If we're currently on an archive case, force reload to today's case
                   if (searchParams.get('date')) {
                     e.preventDefault();
                     window.location.href = '/';
                   }
                 }}
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              className={`text-sm lg:text-base font-oswald font-medium tracking-wide transition-colors duration-200 whitespace-nowrap ${
                         isActive('/')
                           ? 'text-white border-b-2 border-white'
                           : 'text-[#EAE6F8] hover:text-white'
                       }`}
                               >
                  Puzzle
                </Link>
              
              <div className="w-px h-3 bg-white bg-opacity-30"></div>
              
              <Link 
                to="/getting-started" 
                className={`text-sm lg:text-base font-oswald font-medium tracking-wide transition-colors duration-200 whitespace-nowrap ${
                  isActive('/getting-started') 
                    ? 'text-white border-b-2 border-white' 
                    : 'text-[#EAE6F8] hover:text-white'
                }`}
              >
                Learn
              </Link>
              
              <div className="w-px h-3 bg-white bg-opacity-30"></div>
              
              <Link 
                to="/archive"
                className={`text-sm lg:text-base font-oswald font-medium tracking-wide transition-colors duration-200 whitespace-nowrap ${
                  isActive('/archive') 
                    ? 'text-white border-b-2 border-white' 
                    : 'text-[#EAE6F8] hover:text-white'
                }`}
              >
                Archive
              </Link>
              
              <div className="w-px h-3 bg-white bg-opacity-30"></div>
              
              <Link 
                to="/blog" 
                className={`text-sm lg:text-base font-oswald font-medium tracking-wide transition-colors duration-200 whitespace-nowrap ${
                  isActive('/blog') 
                    ? 'text-white border-b-2 border-white' 
                    : 'text-[#EAE6F8] hover:text-white'
                }`}
              >
                Blog
              </Link>
              
              <div className="w-px h-3 bg-white bg-opacity-30"></div>
              
                            <Link 
                to="/stats" 
                                                                  className={`text-sm lg:text-base font-oswald font-medium tracking-wide transition-colors duration-200 whitespace-nowrap ${
                    isActive('/stats') 
                      ? 'text-white border-b-2 border-white' 
                      : 'text-[#EAE6F8] hover:text-white'
                  }`}
              >
                Stats {getStreakCount() > 0 && (
                                      <span className="inline-flex items-center justify-center bg-purple-200 bg-opacity-90 text-purple-800 text-xs font-bold ml-1 rounded-xl px-2 py-0.5 shadow-lg">
                                        {getStreakCount()}
                                      </span>
                                    )}
              </Link>
              
              <div className="w-px h-3 bg-white bg-opacity-30"></div>
              
              <Link 
                to="/about" 
                                                                                                                                                                                                                                                                                                                                                                                                                       className={`text-sm lg:text-base font-oswald font-medium tracking-wide transition-colors duration-200 whitespace-nowrap ${
                      isActive('/about') 
                        ? 'text-white border-b-2 border-white' 
                        : 'text-[#EAE6F8] hover:text-white'
                    }`}
                              >
                  About
                </Link>
           </div>
          

        </div>

        {/* Mobile Navigation */}
        <div className="md:hidden">
          <div className="flex items-center justify-between h-12">
                                                   <div className="flex items-center space-x-2">
                               <Link 
                  to="/" 
                  onClick={(e) => {
                    // If we're currently on an archive case, force reload to today's case
                    if (searchParams.get('date')) {
                      e.preventDefault();
                      window.location.href = '/';
                    }
                  }}
                                                                                                                                                       className={`text-sm font-oswald font-medium tracking-wide transition-colors duration-200 ${
                       isActive('/') 
                         ? 'text-white border-b-2 border-white' 
                         : 'text-[#EAE6F8] hover:text-white'
                     }`}
                                 >
                   Puzzle
                 </Link>
               
                <div className="w-px h-2 bg-white bg-opacity-30"></div>
               
                <Link 
                  to="/getting-started" 
                  className={`text-sm font-oswald font-medium tracking-wide transition-colors duration-200 ${
                    isActive('/getting-started') 
                      ? 'text-white border-b-2 border-white' 
                      : 'text-[#EAE6F8] hover:text-white'
                  }`}
                >
                  Learn
                </Link>
               
                <div className="w-px h-2 bg-white bg-opacity-30"></div>
               
                                <Link 
                  to="/archive" 
                  className={`text-sm font-oswald font-medium tracking-wide transition-colors duration-200 ${
                    isActive('/archive') 
                      ? 'text-white border-b-2 border-white' 
                      : 'text-[#EAE6F8] hover:text-white'
                  }`}
                >
                  Archive
                </Link>
                
                <div className="w-px h-2 bg-white bg-opacity-30"></div>
                
                <Link 
                  to="/blog" 
                  className={`text-sm font-oswald font-medium tracking-wide transition-colors duration-200 ${
                    isActive('/blog') 
                      ? 'text-white border-b-2 border-white' 
                      : 'text-[#EAE6F8] hover:text-white'
                  }`}
                >
                  Blog
                </Link>
                
                <div className="w-px h-2 bg-white bg-opacity-30"></div>
                
                <Link 
                  to="/stats" 
                                                                           className={`text-sm font-oswald font-medium tracking-wide transition-colors duration-200 ${
                      isActive('/stats') 
                        ? 'text-white border-b-2 border-white' 
                        : 'text-[#EAE6F8] hover:text-white'
                    }`}
                >
                                     Stats {getStreakCount() > 0 && (
                     <span className="inline-flex items-center justify-center bg-purple-200 bg-opacity-90 text-purple-800 text-xs font-bold ml-1 rounded-xl px-1.5 py-0.5 shadow-lg">
                       {getStreakCount()}
                     </span>
                   )}
                </Link>
                
                <div className="w-px h-2 bg-white bg-opacity-30"></div>
                
                                <Link 
                  to="/about" 
                                                                           className={`text-sm font-oswald font-medium tracking-wide transition-colors duration-200 ${
                      isActive('/about') 
                        ? 'text-white border-b-2 border-white' 
                        : 'text-[#EAE6F8] hover:text-white'
                    }`}
                                 >
                   About
                 </Link>
             </div>
            

          </div>
        </div>
      </div>
    </nav>

    {/* Logo banner - show on blog pages, links to main page */}
    {isBlogPage && (
      <div className="pt-1 px-2 pb-0 sm:pt-1 sm:px-4 sm:pb-0">
        <div className="flex justify-center mb-3">
          <div className="w-full md:max-w-xl">
            <Link to="/" className="block">
              <img 
                src={gettingStartedImgAlt} 
                alt="Dimension Flux" 
                style={{ 
                  width: '100%', 
                  borderRadius: '1.5rem', 
                  boxShadow: '0 4px 32px 0 rgba(80, 0, 120, 0.10)', 
                  objectFit: 'contain', 
                  objectPosition: 'center' 
                }} 
              />
            </Link>
          </div>
        </div>
      </div>
    )}

    {/* Book promo banner - show on blog pages, below logo - HIDDEN (can be restored later) */}
    {/* {isBlogPage && (
      <div className="px-2 sm:px-4">
        <div className="w-full max-w-xl mx-auto mb-4">
          <Link to="/book" className="block px-2 sm:px-4">
            <div className="flex flex-row items-stretch bg-white/95 border border-slate-200 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-200 overflow-hidden">
              <img src={book0} alt="Dimension Flux Book" className="h-full w-16 sm:w-20 md:w-24 object-cover flex-shrink-0" />
              <div className="flex-1 flex flex-col justify-center min-w-0 p-2 sm:p-3 md:p-4">
                <h3 className="text-xs sm:text-sm md:text-base lg:text-lg font-oswald font-bold text-slate-900 leading-tight mb-1 sm:mb-2.5 whitespace-nowrap overflow-hidden text-ellipsis">
                  50 NEW DIMENSION FLUX PUZZLES TO TAKE OFFLINE.
                </h3>
                <span className="text-xs sm:text-xs md:text-sm text-slate-700 font-oswald uppercase tracking-wide leading-tight whitespace-nowrap overflow-hidden text-ellipsis">LEARN ABOUT THE DIMENSION FLUX BOOK</span>
              </div>
            </div>
          </Link>
        </div>
      </div>
    )} */}
    
    {/* Book promo banner - show on all pages except the main page, book page, and blog pages - HIDDEN (can be restored later) */}
    {/* {!isMainPage && !isBookPage && !isBlogPage && (
      <div className="pt-1 px-2 sm:px-4">
        <div className="w-full max-w-xl mx-auto mb-3 mt-2">
          <Link to="/book" className="block px-2 sm:px-4">
            <div className="flex flex-row items-stretch bg-white/95 border border-slate-200 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-200 overflow-hidden">
              <img src={book0} alt="Dimension Flux Book" className="h-full w-16 sm:w-20 md:w-24 object-cover flex-shrink-0" />
              <div className="flex-1 flex flex-col justify-center min-w-0 p-2 sm:p-3 md:p-4">
                <h3 className="text-xs sm:text-sm md:text-base lg:text-lg font-oswald font-bold text-slate-900 leading-tight mb-1 sm:mb-2.5 whitespace-nowrap overflow-hidden text-ellipsis">
                  50 NEW DIMENSION FLUX PUZZLES TO TAKE OFFLINE.
                </h3>
                <span className="text-xs sm:text-xs md:text-sm text-slate-700 font-oswald uppercase tracking-wide leading-tight whitespace-nowrap overflow-hidden text-ellipsis">LEARN ABOUT THE DIMENSION FLUX BOOK</span>
              </div>
            </div>
          </Link>
        </div>
      </div>
    )} */}
    </>
  );
};

export default TopNavigation;
